export enum PaymentPlan {
  PRO = "pro",
  TEAM = "team",
  TRIAL = "trial",
  ENTERPRISE = "enterprise",
}
